import { BaseModel } from "./base.model";

export class FarmWorkerModel extends BaseModel {
    auto_id?: number;
    farmWorkerId: any;
    farmId: any;
    memberId: any;
    catId: any;
    farmWorkerUseFraction: any;
    fractionId: any;
    farmWorkerAreaH: any;//any;
    farmWorkerAreaAcre: number;//any;
    farmWorkerAreaRelung: number;//any;
    farmWorkerAreaHectare: number;// any;
    farmWorkerActive: any;
    farmWorkerLastUpdate: any;
    farmWokerPersonUpdate: any;
    fractionNominator: any;
    fractionDenominator: any;
    farmWorkerAreaRood:  number;//any;
    farmWorkerAreaPole:  number;//any;
    farmWorkerAreaHWork: any;
    farmWorkerAreaAcreWork:  number;//any;
    farmWorkerAreaRelungWork:  number;//any;
    farmWorkerAreaHectareWork:  number;//any;
    farmWorkerAreaRoodWork:  number;//any;
    farmWorkerAreaPoleWork:  number;//any;
    farmWorkerSubCatId: any;
    farmWorkerUseFractionWork: any;
    fractionNominatorWork: any;
    fractionDenominatorWork: any;
    farmWorkerAreaJempa:  number;//any;
    farmWorkerAreaMeter2:  number;//any;
    farmWorkerAreaJempaWork:  number;//any;
    farmWorkerAreaMeter2Work:  number;//any;
    subCatName: any;
    //SubCatId: any;
    memberName: any;
    memberIC: any;
    cardNo: any;
    memberActive: any;
    patgRegId: number;
    patgRegStatusId: number;

    farmWorkerTotalOwnArea: number;
    farmWorkerTotalWorkArea: number;
    farmWorkerTotalOwnWorkArea: number;
    patgLiveMemberId: number | null | undefined;
    
    /**
     * Default constructor
     * @param params Partial properties of Farm Model
     */
    constructor(params: Partial<FarmWorkerModel> = {} as FarmWorkerModel) {
        super();
        Object.assign(this, params);
    }

    static createCopy(objectToCopy: FarmWorkerModel | null): FarmWorkerModel | null{
        if(objectToCopy === null) return null;
        return (JSON.parse(JSON.stringify(objectToCopy)));
    }
}
